import { supportedLocales, useLocale } from "@adsk/alloy-react-locale";
var defaultLanguage = "en";
export var useTranslations = function () {
  return useLocale(function (_a) {
    var locale = _a.locale;
    try {
      return supportedLocales.includes(locale)
        ? require("../i18n/".concat(locale, ".json"))
        : require("../i18n/".concat(defaultLanguage, ".json"));
    } catch (_b) {
      return require("../i18n/".concat(defaultLanguage, ".json"));
    }
  });
};
